import * as messageHelper from "../../helpers/messageHelper";
import * as methods from "../../constants/serverMethods";
import * as modalTypes from "../../constants/modalTypes";
import * as navigationActions from "../../actions/navigationActions";
import * as objectTypes from "../../constants/objectTypes";
import * as responseValidationHelper from "../../helpers/responseValidationHelper";
import * as universalObjectActions from "../../actions/universalObjectActions";
import * as websocketActions from "../../actions/websocketActions";

import { FileCategory, mapFileCategory } from "../../types/fileCategory";

import { AppState } from "../../reducers";
import { ServerResponse } from "../../types/serverResponse";

export const processServerResponse = (method: string, response: ServerResponse, state: AppState): Array<any> => {
    switch (method) {
        case methods.METHOD_GET_ALL_FILE_CATEGORIES_NO_PARAMS: {
            if (!responseValidationHelper.isArrayResponseValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            const fileCategoryList: Array<FileCategory> = [];
            let fileCategory: FileCategory | null;

            for (const item of response.data.data) {
                fileCategory = mapFileCategory(item);

                if (fileCategory) {
                    fileCategoryList.push(fileCategory);
                }
            }

            return [universalObjectActions.saveItemsNoParams(objectTypes.FILE_CATEGORY, fileCategoryList)];
        }
        case methods.METHOD_GET_ALL_FILE_CATEGORIES: {
            if (!responseValidationHelper.isArrayResponseValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            const fileCategoryList: Array<FileCategory> = [];
            let fileCategory: FileCategory | null;

            for (const item of response.data.data) {
                fileCategory = mapFileCategory(item);

                if (fileCategory) {
                    fileCategoryList.push(fileCategory);
                }
            }

            return [universalObjectActions.saveItems(objectTypes.FILE_CATEGORY, fileCategoryList, response.data.count)];
        }
        case methods.METHOD_ADD_FILE_CATEGORY: {
            if (!responseValidationHelper.isResponseValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                universalObjectActions.dataChanged(true),
                universalObjectActions.reloadData(objectTypes.FILE_CATEGORY),
                universalObjectActions.getAllItems(objectTypes.FILE_CATEGORY),
                navigationActions.navigationCloseModal(modalTypes.MODAL_FILE_CATEGORIES_ADD)
            ];
        }
        case methods.METHOD_EDIT_FILE_CATEGORY: {
            if (!responseValidationHelper.isResponseValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                universalObjectActions.dataChanged(true),
                universalObjectActions.reloadData(objectTypes.FILE_CATEGORY),
                universalObjectActions.getAllItems(objectTypes.FILE_CATEGORY),
                navigationActions.navigationCloseModal(modalTypes.MODAL_FILE_CATEGORIES_EDIT)
            ];
        }
        case methods.METHOD_DELETE_FILE_CATEGORY: {
            if (!responseValidationHelper.isResponseValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                universalObjectActions.dataChanged(true),
                universalObjectActions.reloadData(objectTypes.FILE_CATEGORY),
                universalObjectActions.getAllItems(objectTypes.FILE_CATEGORY),
                universalObjectActions.setActiveItems(objectTypes.FILE_CATEGORY, [])
            ];
        }
        default: {
            return [websocketActions.serverUnknown()];
        }
    }
};
